import { TagMatchingType } from "entities/modules/types";
import { ModuleTagType } from "entities/tagTypes/types";
import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";
import { TagOption, TagBlock } from "../../../widgets/ModuleTagsWidget/type";

export type TagBlocksStore = {
  tagBlocks: TagBlock[];
  setTagBlocks: (tagBlocks: TagBlock[]) => void;
  addTagBlock: () => void;
  deleteTagBlock: (blockId: string) => void;
  changeTagType: (blockId: string, tagType: ModuleTagType) => void;
  changePrimaryTag: (blockId: string, primaryTagId: string) => void;
  changeTags: (blockId: string, newTags: TagOption[]) => void;
  clearTagsData: () => void;
  changeMatchingType: (blockId: string, matchingType: TagMatchingType) => void;
};

export const useTagBlocksStore = create<TagBlocksStore>((set) => ({
  tagBlocks: [],
  setTagBlocks: (tagBlocks) => set({ tagBlocks }),
  addTagBlock: () => {
    const newBlock: TagBlock = {
      id: uuidv4(),
      tagType: null,
      primaryTagId: null,
      selectedTags: [],
      matchingType: TagMatchingType.EQUALS,
    };

    return set((state) => {
      return {
        tagBlocks: [...state.tagBlocks, newBlock],
      };
    });
  },
  deleteTagBlock: (blockId: string) =>
    set((state) => ({
      tagBlocks: state.tagBlocks.filter((block) => {
        return block.id !== blockId;
      }),
    })),
  changeTagType: (blockId, tagType) =>
    set((state) => ({
      tagBlocks: state.tagBlocks.map((block) => {
        if (block.id === blockId) {
          return {
            ...block,
            tagType,
            primaryTagId: null,
            selectedTags: [],
          };
        }
        return block;
      }),
    })),
  changePrimaryTag: (blockId, primaryTagId) =>
    set((state) => ({
      tagBlocks: state.tagBlocks.map((block) => {
        if (block.id === blockId) {
          return {
            ...block,
            primaryTagId,
          };
        }
        return block;
      }),
    })),
  changeTags: (blockId, newTags) =>
    set((state) => ({
      tagBlocks: state.tagBlocks.map((block) => {
        if (block.id === blockId) {
          return {
            ...block,
            selectedTags: newTags,
          };
        }
        return block;
      }),
    })),
  clearTagsData: () =>
    set({
      tagBlocks: [],
    }),
  changeMatchingType: (blockId, matchingType) =>
    set((state) => ({
      tagBlocks: state.tagBlocks.map((block) => {
        if (block.id === blockId) {
          return { ...block, matchingType };
        }
        return block;
      }),
    })),
}));
